import mustache from "mustache";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import template from "./precioMercadoTemplate.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let PRECIO_MERCADO_ID = 0;

/** Tile "Precio mercado" del dashboard de Pesaje/Ganadería: input numérico
 *  siempre editable (sin persistir — vive solo en memoria, para alimentar
 *  otros cálculos del dashboard). Sin valor por defecto. */
export class PrecioMercadoStatRender implements IConnectRender {
  private readonly _tileId: number;

  constructor() {
    PRECIO_MERCADO_ID += 1;
    this._tileId = PRECIO_MERCADO_ID;
  }

  /** Precio actual (o `null` si no se ingresó todavía). */
  getPrecio(): number | null {
    return this._precio;
  }

  /** Notifica en vivo cada vez que cambia el valor del input. */
  setOnChange(handler: (precio: number | null) => void): void {
    this._onChange = handler;
  }

  render(): string {
    return mustache.render(template, {
      id: this._tileId,
      valorInicial: this._precio ?? "",
    });
  }

  connect(): void {
    this._input = document.getElementById(
      `pgd-precio-input-${this._tileId}`,
    ) as HTMLInputElement | null;
    this._input?.addEventListener("input", this._onInput);
  }

  dispose(): void {
    this._input?.removeEventListener("input", this._onInput);
  }

  private _precio: number | null = null;
  private _onChange: ((precio: number | null) => void) | null = null;
  private _input: HTMLInputElement | null = null;

  private _onInput = (): void => {
    if (!this._input) return;
    const raw = this._input.value.trim();
    this._precio = raw === "" ? null : Number(raw);
    this._onChange?.(this._precio);
  };
}
